import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminService } from '../admin/admin.service';
import { DataToolsApps } from '../shared/DataToolsApps';
import { AuthServiceService } from './auth-service.service';

@Injectable()
export class AuthGuard implements CanActivate {

  app: string;

  constructor(private router: Router,
              private adminService: AdminService,
              private authService: AuthServiceService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.debug(`Route -> ${route.routeConfig.path}`);
    if (!this.authService.checkAuthIsValid()) {
      console.warn('Auth is not valid');
      const queryParam = route.queryParams['dataCenter'] ? route.queryParams['dataCenter'] : route.queryParams['dataCentre'];
      this.authService.initialiseAuthWithDataCentre(queryParam);
      return false;
    }

    this.app = route.routeConfig.path.split('/')[0];

    console.debug('auth guard', this.app);

    if (this.app === '') {
      console.debug('landing page', this.app);
      return new Observable<boolean>(obs => {
        this.adminService.finishedLoading$.subscribe(success => {
          if (success) { obs.next(true); }
        });
      });
    }

    return new Observable<boolean>(obs => {
      this.adminService.finishedLoading$.subscribe(success => {
        if (success) {
          switch (this.app) {
            case 'datatools-settings' :
              obs.next(true);
              console.debug('datatools-settings', this.app);
              break;
            case 'duplikit' :
              obs.next(this.adminService.checkAppEnabled(DataToolsApps.DUPLIKIT));
              console.debug('duplikit', this.app);
              break;
            case 'datacleaner' :
              obs.next(this.adminService.checkAppEnabled(DataToolsApps.DATA_CLEANER));
              console.debug('datacleaner', this.app);
              break;
            case 'datarules' :
              obs.next(this.adminService.checkAppEnabled(DataToolsApps.DATARULES));
              console.debug('datarules', this.app);
              break;
            case 'userManagement' :
              obs.next(this.adminService.userStatus.adminUser);
              console.debug('userManagement', this.app);
              break;
            case 'history' :
              obs.next(true);
              console.debug('history', this.app);
              break;
            case 'enrichmentSettings' :
              obs.next(true);
              break;
            case 'enrichment' : // TODO: add entitlement for enrichment.
              obs.next(true);
              break;
            default:
              console.debug('auth guard default!');
              obs.next(false);
          }
        }
      });
    });
  }
}
